import type { WSShiftFragment } from "@/graphql";
import { toUnix } from "@/stories/utils/dates";
import type { Ref } from "vue";

export interface IWSShiftItem {
  name: string;
  avatar: string;
  startDate: number;
  endDate: number;
  isUnavailable?: boolean | undefined;
  isCancelledShift?: boolean | undefined;
  isNightShift?: boolean | undefined;
}

const toList = (items: Ref<WSShiftFragment[]>) => {
  return items.value
    .filter((item: WSShiftFragment) => {
      return toUnix(new Date(item.end)) > toUnix(new Date());
    })
    .map((item: WSShiftFragment) => {
      return {
        name: item.employee.displayName,
        avatar: item.employee.displayImage,
        startDate: toUnix(new Date(item.start)),
        endDate: toUnix(new Date(item.end)),
        isUnavailable: !!item.unavailable,
        isCancelledShift: item.cancelled,
        isNightShift: item.nightShift,
      } as IWSShiftItem;
    });
};

export default {
  toList,
};
